import { useContext } from 'react';
import { SetPendingScrollContext } from '../context';

export function useScrollToBottomOfMessages() {
  const scrollContext = useContext(SetPendingScrollContext);

  return scrollContext;
}